module.exports = __webpack_public_path__ + "img/9.829e8331.jpg";